"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormFieldLayout = exports.formFieldLayoutTypes = exports.INLINE = exports.DEFAULT = void 0;
const React = require("react");
const styles = require("./styles.scss");
const cssComposer_1 = require("../../../../../../helpers/cssComposer");
const css = (0, cssComposer_1.default)(styles);
exports.DEFAULT = "DEFAULT";
exports.INLINE = "INLINE";
exports.formFieldLayoutTypes = {
    DEFAULT: "-default",
    INLINE: "-inline"
};
/**
 * Renders a collection of fields in a chosen layout.
 */
const FormFieldLayout = ({ children, layout = false }) => {
    layout = layout || exports.formFieldLayoutTypes.DEFAULT;
    return (React.createElement("div", { className: css("formFieldLayout", layout) }, React.Children.map(children, (field, i) => field && (React.createElement("div", { key: i, className: css("formFieldLayout_field") }, field)))));
};
exports.FormFieldLayout = FormFieldLayout;
exports.default = exports.FormFieldLayout;
//# sourceMappingURL=index.js.map